import { connect } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import BoxWraper from "../box-wrapper";
import {
  fetchAccount,
  fetchUserPricingPlans,
  changePricingPlan,
  updateAccount,
  pausePayment,
  unPausePayment,
  cancelPayment,
  unCancelPayment
} from "./ducks/actions";

import Account from "./account";
import { useEffect } from "react";
import Loader from "../../shared/loader";
import auth from "../../shared/auth";
import { logout } from "../../app/ducks/actions";
import confirm from "../../shared/modal/confirm";

const AccountContainer = (props) => {
  const {
    fetchAccount,
    fetchPricingPlans,
    changePricingPlan,
    updateAccount,
    loading,
    updating,
    errors,
    account,
    pricingPlans,
    pausePayment,
    resumePayment,
    cancelPayment,
    unCancelPayment,
    pristine,
    redirect,
    initialPricingPlanType
  } = props;

  const history = useHistory();

  useEffect(() => {
    fetchAccount();
    fetchPricingPlans();
  }, []);

  const onChangePricingPlan = (pricingPlanType: any) => {
    changePricingPlan(pricingPlanType)
  };

  const onUpdate = () => {
    updateAccount(account);
  };

  const onUpgradePlan = () => {
    confirm(
      () => {
        // Get the selected pricing plan type, default to a paid plan (e.g., 1) if not set
        const pricingPlanType = account.pricingPlanType || 1;
        history.push(`/payment/${pricingPlanType}`);
      },
      null,
      "You're about to upgrade to a paid plan. You'll be taken to the payment page to set up your payment method and complete the upgrade.",
      "Upgrade Plan"
    );
  };

  const onLogout = () => {
    auth.logout();
    // redirect to login
    logout(props.history);
    props.history.push('/login');
  };

  if (redirect) {
    return <Redirect to={redirect.to} />;
  }

  return (
    <BoxWraper width={5}>
      {(loading || updating) && <Loader />}
      {!loading &&
        <Account
          errors={errors}
          account={account}
          pricingPlans={pricingPlans}
          changePricingPlan={onChangePricingPlan}
          update={onUpdate}
          pausePayment={pausePayment}
          resumePayment={resumePayment}
          cancelPayment={cancelPayment}
          unCancelPayment={unCancelPayment}
          pristine={pristine}
          onLogout={onLogout}
          onUpgradePlan={onUpgradePlan}
          initialPricingPlanType={initialPricingPlanType} />}
    </BoxWraper>
  )
}

function mapStateToProps(state) {
  const { accountState } = state;
  return {
    account: accountState.accountState.account,
    pricingPlans: accountState.accountState.pricingPlans,
    errors: accountState.accountState.errors,
    loading: accountState.accountState.loading,
    updating: accountState.accountState.updating,
    pristine: accountState.accountState.pristine,
    redirect: accountState.accountState.redirect,
    initialPricingPlanType: accountState.accountState.initialPricingPlanType
  };
}

export default connect(mapStateToProps, {
  fetchAccount,
  fetchPricingPlans: fetchUserPricingPlans,
  changePricingPlan,
  updateAccount,
  pausePayment,
  resumePayment: unPausePayment,
  cancelPayment,
  unCancelPayment
})(AccountContainer);